/* eslint-disable react/no-danger */
import React from "react";
import Branches from "components/Branches";
import ContactUs from "components/ContactUs";
import Layout from "components/Layout";
import Partners from "components/Partners";
import SendMoney from "components/SendMoney";
import SEO from "components/SEO";
import Services from "components/Services";
import BecomeFranchiseeSection from "components/BecomeFranchiseeSection";
import Vlog from "components/Vlog";

const IndexPage = () => {
  return (
    <Layout>
      <SEO />

      <section className="mt-16">
        <SendMoney />
      </section>

      <Branches />
      <Services />
      <BecomeFranchiseeSection />
      <Vlog />
      <Partners />
      <ContactUs />
    </Layout>
  );
};

export default IndexPage;
